// Features Accordion Initialization
(function() {
  'use strict';
  
  // Use requestIdleCallback for non-blocking execution, fallback to RAF
  function scheduleInit(callback) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout: 2000 });
    } else if ('requestAnimationFrame' in window) {
      requestAnimationFrame(callback);
    } else {
      setTimeout(callback, 0);
    }
  }
  
  function initFeaturesAccordion() {
    // Cache DOM queries - only query once
    const wrapper = document.querySelector('.features-accordion-wrapper');
    const accordionContainer = document.querySelector('.features-accordion-modern');
    
    if (!wrapper || !accordionContainer) return;
    
    // Single query for content container
    const contentDiv = wrapper.querySelector('.metafield-rich_text_field') || wrapper;
    
    // Single query for all paragraphs - more efficient than multiple queries
    const paragraphs = contentDiv.querySelectorAll('p');
    const totalItems = paragraphs.length;
    
    if (totalItems === 0) {
      wrapper.style.display = 'block';
      wrapper.classList.add('features_details', 'custom-list');
      return;
    }
    
    // Use DocumentFragment to batch DOM operations and minimize reflows
    const fragment = document.createDocumentFragment();
    let itemsCreated = 0;
    
    // Single pass through DOM - cache tagName checks
    for (let i = 0; i < totalItems; i++) {
      const para = paragraphs[i];
      const strong = para.querySelector('strong');
      
      if (!strong) continue;
      
      const title = strong.textContent.trim();
      if (!title) continue;
      
      // Efficient sibling traversal - stop at first UL
      let ul = para.nextElementSibling;
      while (ul && ul.tagName !== 'UL') {
        ul = ul.nextElementSibling;
      }
      
      if (!ul) continue;
      
      const li = ul.firstElementChild;
      if (!li || li.tagName !== 'LI') continue;
      
      const description = li.textContent.trim();
      if (!description) continue;
      
      // Build accordion item structure
      const details = document.createElement('details');
      details.className = 'cc-accordion-item';
      
      const summary = document.createElement('summary');
      summary.className = 'cc-accordion-item__title';
      summary.textContent = title;
      
      const panel = document.createElement('div');
      panel.className = 'cc-accordion-item__panel';
      
      const contentDivEl = document.createElement('div');
      contentDivEl.className = 'cc-accordion-item__content rte';
      contentDivEl.textContent = description;
      
      // Build structure before appending
      panel.appendChild(contentDivEl);
      details.appendChild(summary);
      details.appendChild(panel);
      
      // Add to fragment (no reflow yet)
      fragment.appendChild(details);
      itemsCreated++;
    }
    
    // Single DOM update - append all items at once
    if (itemsCreated > 0) {
      accordionContainer.appendChild(fragment);
      accordionContainer.style.display = 'block';
      wrapper.style.display = 'none';
    } else {
      wrapper.style.display = 'block';
      wrapper.classList.add('features_details', 'custom-list');
    }
  }
  
  // Optimized initialization - check readyState once
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    scheduleInit(initFeaturesAccordion);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      scheduleInit(initFeaturesAccordion);
    }, { once: true });
  }
})();


